
/*
  前缀：
  ph_ 输入框placeholder
  tip_ 校验提示信息
  confirm_ 二次确认提示
  message_ 一般性描述
  header_ 表格header
*/
export default {
  projectOutlined: 'Projects',
  documentManagement: 'Document management',
  questionCircleOutlined: 'Help',
  manual: 'Manual',
  login_title: 'DOTS-AD',
  user: 'User',
  team: 'Team',
  client: 'Client',
  internal: 'Internal',
  login: 'Sign in',
  recommend: 'Please use chrome for best experience',
  copyright: '',
  register: 'Register',
  forget: 'Forget password',
  acceptance_project: 'Projects',
  header_project_id: 'Project ID',
  header_project_name: 'Project Title',
  project_id: 'Project ID',
  project_id_colon: 'Project ID：',
  project_name: 'Project Title',
  project_name_colon: 'Project Title：',
  look_up: 'View',
  statistics: 'Statistic',
  total_count: 'Total',
  pending_count: 'Pending',
  checking_count: 'Processing',
  passing_count: 'Accepted',
  passing_count_msg: 'passing_count_msg',
  operate: 'Action',
  check_batch_id: 'Batch ID',
  check_status: 'Data Status',
  inspector: 'Acceptance personnel',
  inspector1: 'Acceptance personnel',
  examine_time: 'Start Time',
  examine: 'Random Data',
  pass: 'Accept',
  reject: 'Reject',
  acceptance_examine: 'Random Data',
  check_proportion: 'Please enter the random ratio of data',
  check_message: 'Please enter an integer between (0, 100)',
  check_invalid: 'Contains invalid data',
  check_frame_proportion: 'Please enter the random ratio of frame',
  ph_check_frame_proportion: 'Radio of frame',
  check_batch_list: 'Data Batch Lists',
  check_confirm: 'There are still {num} pieces of unaccepted data in the random inspection, confirm the unaccepted data of batch【{type}】？',
  // not_accepted: 'Not sampled',
  not_accepted: 'Not accepted',
  to_be_checked: 'To be accepted',
  checking: 'Acceptance',
  check_revoked: 'Revoked',
  check_reject: 'Reject',
  check_pass: 'Accept',
  comprehensive_check_pass: 'Comprehensive check pass',
  comprehensive_check_pass_msg: 'comprehensive_check_pass_msg',
  check_pass_msg: 'comprehensive_check_pass_msg',

  inspection_data_frame: 'Data Volume/Images Volume/Effective Images',
  spot_data_fame: 'Random Data Volume/Random Images Volume',
  pass_frame_count: 'Qualified Images Volume',
  fail_frame_count: 'Unqualified Images Volume',
  frame_pass_rate: 'Images Approval Rate',
  object_pass_rate: 'Bounding Boxes Approval Rate',
  object_pass_rate_manual: 'Object pass rate by manual',
  object_pass_rate_not_manual: 'Object pass rate by not manual',
  start_check_at: 'Start Time',
  submitted_at: 'End Time',
  check_time: 'Time-consuming',

  examine_number: 'Inspection frames/Qualified frames/Unqualified frames',
  check_date: 'Create Date',
  project_inspector_statistics: 'Project Statistic',
  project_statistics: 'Statistic',
  batch_statistics: 'Batches Statistic',
  check_record: 'Record',

  check_num: 'Data Volume',
  check_frame_num: 'Images Volume',
  object_total_count: 'Bounding Boxes volume',
  project_points_accuracy: 'Project points accuracy',
  batch_points_accuracy: 'Batch points accuracy',
  pre_object_total_count: 'pre object total count',
  check_data_rate: 'Approval Rate',
  check_frame_rate: 'Images Approval Rate',
  check_frame_precise_rate: 'Frame Accuracy',
  check_object_rate: 'Bounding Boxes Approval Rate(Total)',
  object_statistics: 'Bounding Boxes Volume',
  object_rate: 'Bounding Boxes Approval Rate',
  two_point_five_d: '2.5D',
  point: 'Point',
  line: 'Line',
  box: 'Box',
  rectangle: 'Rectangle',
  rectangle3: 'Rectangle',
  polygon: 'Polygon',
  oval: 'Oval',
  sidebox: 'Sidebox',
  pseudo: '2.5D Bounding Boxes',
  pseudo2: 'Stereo Frame',
  rectangle_3d: '3D Bounding Boxes',
  line_3d: '3D Line',
  polygon_3d: '3D Polygon',
  point_3d: '3D Point',
  date: 'Date',
  register_title: 'Visual annotation platform registration',
  nationality: 'Nationality',
  tip_choose_country: 'Please select a country',
  now_address: 'Current Location',
  domestic: 'Domestic',
  abroad: 'Abroad',
  account_type: 'Account Type',
  phone: 'Phone',
  email: 'Mailbox',
  supplier_name: 'Team Name',
  ph_supplier: 'Please enter the name of the team',
  name: 'Name：',
  name1: 'Name',
  ph_choose_supplier: 'Please select the team',
  ph_name: 'Please enter your name',
  ph_account_name: 'Please enter your name or account',
  login_phone: 'Phone',
  ph_phone: 'Please enter the phone',
  login_email: 'Login mailbox',
  ph_email: 'Please enter the mailbox',
  password: 'Password',
  ph_pass_len: 'Must contain English and numbers, more than 8 digits',
  confirm_pass: 'Confirm Password',
  ph_confirm_pass: 'Please enter the confirmation password',
  tissue_id: 'Organization ID',
  ph_tissue_id: 'Please enter the organization ID',
  ph_ver_code: 'Please enter the verification code',
  ph_login_ver_code: 'Please enter google verification code',
  ver_code: 'Verification Code',
  get_ver_code: 'Verification code',
  ph_pass: 'Please enter the password',
  tip_pass: 'The length is 8~14; Alphanumeric and punctuation symbols shall contain at least 2 types; Space and Chinese are not allowed',
  tip_phone_format: 'Incorrect phone format',
  tip_email_format: 'Incorrect mailbox format',
  tip_pass_len: 'The password length cannot be less than 8 digits',
  tip_pass_match: 'The password is inconsistent with the confirmation password',
  tip_emial_success: 'The activation link has been sent to the mailbox, please log in to the mailbox for verification!',
  tip_register_sucess: 'Register successfully!',
  resend: 'Resend',
  tip_repass: 'Please enter the password again',
  tip_pass_different: ' The two passwords are inconsistent, please check!',
  forget_pass_title: 'Forgot your password?',
  phone_email: 'Phone/Email',
  ph_phone_email: 'Please enter the phone/email',
  new_pass: 'New Password',
  ph_new_pass: 'Please enter the verification code',
  complete: 'Finish',
  ph_account: 'Please enter the account number',
  tip_pass_success: 'Password changed successfully!',
  ph_phone_email1: 'Please enter your phone or email',
  ph_password: 'Please enter password',
  ph_auth: 'Please select a user',
  ph_project_id: 'Please enter the project ID',
  ph_project_name: 'Please enter the project name',
  ph_check_batch_id: 'Please input batch ID',
  ph_check_status: 'Please select acceptance status',
  ph_inspector: 'Please Select an acceptor',
  ph_date: 'Please select a date',
  ph_auth_uid: 'Please select the account you want to log in',
  ph_check_proportion: 'Please enter the correct sampling ratio',
  ph_team: 'Please select a team',
  get_user_list_success: 'Get the list of people successfully',
  tip_kick: 'Click Confirm, and the account logged in by other login devices will no longer be available.',
  continue_login: 'Continue to log in',
  request_failed: 'Request Fail!',
  search: 'Search',
  reset: 'Reset',
  ok: 'Ok',
  cancel: 'Cancel',
  confirm: 'Confirm',
  export: 'Export',
  start_time: 'Start Date',
  end_time: 'End Date',
  //frame
  token_error: 'Token exception',
  home_page: 'Home Page',
  home_page2: 'Overview',
  home_page_tab1: 'User Distribution',
  home_page_tab2: 'Data Statistics',
  home_page_tab3: 'Project Overview',
  home_page_active_user: 'Current Online Users',
  home_page_active_team: 'Current Online Team',
  config_management: 'Configuration',
  base_config: 'Basic Configuration',
  link_config: 'Segment Configuration',
  new_project: 'New Project',
  improt_export_rules: 'Data Rules',
  pm: 'Project Manager',
  pm_operation_manual: 'PM Tutorial',
  supplier_operation_manual: 'Team Tutorial',
  operator_operation_manual: 'Operator Tutorial',
  acceptance_operation_manual: 'Acceptance Tutorial',
  exit: 'Exit',
  exit_success: 'Exit successfully',
  bind_dingtalk_account: 'Bind Ding Talk account',
  dingtalk_account: 'Ding Talk account',
  ph_dingtalk_account: 'Please enter the Ding Talk account',
  //创建1
  project_type: 'Project type',
  shibiao_project: 'Project Bid Trial',
  formal_project: 'Formal project',
  project_desc: 'Project description',
  ph_project_desc: 'Please enter the project description',
  start_end_date: 'Start and end date',
  required_filed: 'Required fields',
  associated_project: 'Associated project',
  ph_hive_plactform: 'Please select a project in the hive platform',
  storage_address: 'Storage address',
  project_member: 'Project members',
  none_selected_person: ' non-selected',
  selected_person: ' selected',
  optional_selected: ' optional',
  selected1: ' selected',
  save: 'Save',
  next: 'Next step',
  ph_project_type: 'Please select the project type',
  ph_associated_project: 'Please select the project associated project',
  ph_start_end_date: 'Please select the project start and end date',
  ph_storage_address: 'Please select the storage address',
  ph_platform_associated_project: 'Please select the associated project of the work platform',
  ph_associated_project1: 'Please select the associated project',
  project_create_message: 'If you need to access pre-identification, please synchronize algorithm and platform development in a timely manner!',
  prompt: 'prompt',
  project_create_message_ok: 'I see',
  language: 'language',
  language_tip: 'Please select language',
  //创建2
  tool_selection: 'Tool Selection',
  user_selection: 'User Selection',
  tool: 'Tool',
  ph_select: 'Please select',
  ph_enter: 'Please enter',
  select: 'Select',
  tip_to_tool_list: 'You can view and edit (owner) tool configurations in detail, the tools used by the project only support editing part of the configuration',
  box_errors: 'Box error group',
  ph_select_attr_template: 'Please select the box property template',
  refresh: 'Refresh',
  tip_create: 'You need to click the refresh button after the new creation',
  tip_refresh: 'The list will be reloaded after refreshing',
  create_box_errors: 'Create new box error group',
  maintain_box_errors: 'Maintenance box error group',
  pic_invalid_reason: 'Invalid reason',
  select_all: 'Select All',
  create_pic_invalid_reason: 'Create new reason for invalid image',
  pre: 'Previous step',
  box_errors_management: 'Box error group management',
  pic_invalid_reason_management: 'Image invalidation reason management',
  ph_select_tool: 'Please select the tool',
  //创建3
  add_link: 'Add segment',
  type: 'Type',
  name1: 'Name',
  edit_link: 'Editing segment',
  task_complete_time: 'Task completion time',
  rework_max_count: 'Maximum number of rework',
  no: 'No',
  yes: 'Yes',
  allow_cross_rework: 'Cross-level rework is allowed',
  not_allow_cross_rework: 'Cross-level rework is not allowed',
  maintain_link: 'Maintenance segment',
  link_type: 'Segment type',
  anno: 'Start',
  annotation: 'Annotation',
  quality_inspection: 'Quality Inspection',
  quality_inspect: 'Start',
  link_name: 'Segment name',
  link_name_duplicate: 'Duplicate link name',
  on: 'On',
  off: 'Off',
  auto_recycling: 'Automatic recycling',
  link_desc_title: 'Create segment description',
  tip_create_link: '1. The first step must be annotated, and then quality inspection (that is, continuous annotation is not allowed); 2. The last segment must be quality inspection; 3. You cannot add or delete phases when they have tasks.',
  maintain_quality_inspection_strategy: 'Maintain quality inspection strategy',
  ph_link_name: 'Please enter the segment name',
  anno_quality_inspection: 'Mark quality inspection',
  ph_anno_quality_inspection_task: 'Please enter the label and quality inspection task',
  tip_first_not_qi: 'The first segment cannot be quality inspection',
  ph_rework_max_count: 'Please enter the maximum number of rework',
  auto_recycling_title: 'Are you sure to turn on auto-recycle?',
  tip_auto_recycling: 'Some tasks may have already reached the recycling conditions, and may be recycled immediately after the switch is turned on.',
  //创建4
  rule_type: 'Rule type',
  rich_text: 'Rich text',
  pdf_document: 'Pdf document',
  need_reread_by_marker: 'Whether to reread by the annotator',
  need: 'Yes',
  not_need: 'No',
  upload_document: 'Upload document',
  click_drag_upload: 'Click or drag to area to upload',
  look_up_rule_file: 'Click to view the rule file',
  ph_rule_content: 'Please enter the rules',
  ph_upload_file: 'Please enter the upload file',
  ph_rule_countdown_second: 'Please enter the countdown of the rule',
  tip_save_rule_success: 'Save the rules successfully!',
  tip_upload_file_size_10m: 'Upload file size must be less than 10M',
  upload_file_success: 'File uploaded successfully',
  //创建5
  project_base_configuration: 'Basic project configuration',
  edit: 'Edit',
  anno_type: 'Annotation Type',
  mainten_person: 'Maintenance staff',
  tool_config: 'Tool Configuration',
  project_link_config: 'Segment configuration',
  rework_recycling: 'Rework recycling',
  close: 'close',
  open: 'open',
  rule_content: 'Content',
  click_to_view_rule: 'Click to view rules',
  count_down: 'Countdown',
  publish: 'Publish',
  project_rule: 'Rule Description',
  click_to_view_rule_file: 'Click to view the rules document',
  tip_create_project_finished: 'Create project complete!',
  tip_project_publish_success: 'Project published successfully',
  image_error: 'Picture error',

  //数据管理
  reject_reason: 'Rejection reason',
  labeler: 'Annotator',
  ph_labeler: 'Please enter a annotator',
  quality_inspector: 'Quality inspector',
  ph_quality_inspector: 'Please enter the quality inspector',
  picture_attr: 'Picture Properties',
  ph_picture_attr: 'Please select a picture property',
  data_link: 'Segment',
  ph_data_link: 'Please select the segment',
  data_status: 'Data status',
  header_data_status: 'Data status',
  ph_data_status: 'Please select the data status',
  pre_data_status: 'Last acceptance data status',
  ph_pre_data_status: 'Please select the status of the previous round of acceptance data',
  acceptance_id: 'Acceptance ID',
  data_id: 'Data ID',
  ph_acceptance_id: 'Please enter the acceptance ID',
  ph_data_id: 'Please enter the data ID',
  ph_data_id_multiple: 'Please enter the data ID, Use multiple separators',
  acceptance_task_status: 'Acceptance task status',
  ph_acceptance_task_status: 'Please select the acceptance task status',
  ph_acceptance_batch_status: 'Please select the acceptance batch status',
  ph_acceptance_batch_id: 'Please enter the accept batch ID',
  data_effectiveness: 'Data effectiveness',
  ph_data_effectiveness: 'Please select data effectiveness',
  effectiveness: 'Effectiveness',
  ph_effectiveness: 'Please select Effectiveness',
  efficient: 'Efficient',
  invalid: 'Invalid',
  last_commit_time: 'Last submission time',
  last_edit_time: 'Last edit time',
  object_count: 'Object count',
  question_accuracy: 'Question accuracy',
  cumulative_duration: 'Cumulative duration（Second）',
  speed: 'Speed（Second/Object）',
  batch_pass: 'Batch pass',
  batch_reject: 'Batch reject',
  batch_recycling: 'Batch recycling',
  submit_acceptance: 'Submit for acceptance',
  items_selected: '{num} items selected',
  import_file_list_search: 'Import List Search',
  apply_search_result: 'Apply to search result',
  batch_submit_check: 'Subcontracting inspection',
  data_have_been_queried: '{num} data have been queried',
  submit_record: 'Submit record',
  reject_which_session: 'Rejected to which segment',
  ph_recycling_method: 'Please select a recycling method',
  clear_result: 'Empty results',
  keep_result: 'Keep results',
  tip_clear_result1: 'Recycling to annotation pool: Refers to resetting data to the initial state of annotation collection. If there is algorithm pre recognition, the pre recognition results will be loaded. If there is no pre recognition, there will be no annotation results.',
  tip_clear_result2: 'Same stage recycling: does not support clearing results.',
  tip_keep_result1: 'Recycling to annotation pool and same stage recycling: All information such as the latest annotation results, quality inspection and acceptance results, quality inspection and acceptance opinions, annotations, etc. are retained',
  tip_keep_result2: '',
  batch_name: 'Batch name',
  file_name: 'File name',
  ph_file_name: 'Please enter the file name',
  ph_file_name_multiple: 'Please enter the file name, Use multiple separators',
  submission_type: 'Submission type',
  confirm_pass_search_result: 'Determine if the search results are passed?',
  confirm_pass_choose_result: 'Determine if the selected datas are passed?',
  ph_reject_link: 'Please select the rejection segment',
  confirm_reject_search_result: 'Determine if the search results are rejected?',
  confirm_reject_choose_result: 'Determine if the selected datas are rejected?',
  confirm_recycling_search_result: 'Determine if the search results are recalled?',
  confirm_recycling_choose_result: 'Determine if the selected datas are recalled?',
  confirm_submit_search_result: 'Determine whether to submit acceptance of the searched results?',
  confirm_submit_choose_result: 'Determine if the selected data is submitted for acceptance?',
  ph_upload_csv_format: 'Please upload the file in csv format',
  tip_only_one_file_upload: 'Only one file can be uploaded',
  release_message: 'Directed Release within the Same Process:',
  release_ph: 'Other terminal users within the same process can be selected',
  release_multiple: 'Bulk Release',
  reject_multiple: 'Bulk Reject',
  examine_multiple: 'Batch inspection',
  operation_successful: 'Successful operation',
  release_error_message: 'Only data within the same process can be released in bulk!',
  reject_error_message: 'Only data within the same status and process can be rejected in bulk!',
  if_save_result: 'Do you want to keep the results',
  recycle_to_mark: 'Recycle to annotation pool',
  recycle_in_same_link: 'Recycle to annotation pool',
  recycle_method: 'Recovery mode',
  tip_recycle_method1: 'Recycling to annotation pool: Recycling to the initial annotation pool, both annotation and quality inspection are recycled, and acceptance is not recycled.',
  tip_recycle_method2: 'Same stage recycling: Recycling to the same stage data pool. If in the annotation stage, recall the annotation task; If it is in the quality inspection stage, only the quality inspection tasks in this stage will be collected; If it is in the process of repair, it will be recovered from the repair stage to the subsequent stages. For example, if it is marked as repair, both the marking and quality inspection will be recovered, and acceptance will not be recovered.',
  ph_save_result: 'Please choose whether to keep the results',
  sure_delete_batch: 'Are you sure to delete the batch? After batch deletion, it will not be recoverable. Please operate with caution.',

  // 项目管理-统计
  last_update_time: 'Last update time:',
  click_link: 'Click the link',
  project_progress: 'Project progress',
  supplier_progress: 'Team progress',
  person_progress: 'Personnel progress',
  project_data_statistic: 'Project data statistic',
  supplier_data_statistic: 'Team Data Statistic',
  person_data_statistic: 'Personnel data statistic',
  project_pass_rate: 'Project pass rate',
  supplier_pass_rate: 'Team pass rate',
  person_pass_rate: 'Personnel pass rate',
  attribute_statistic: 'Attribute statistic',
  person_staff: 'Staff hourly wages',
  submitted_today: 'Submit data on the same day',
  submitted_today_object: 'Submit elements today',
  submitted_today_object_ai: 'Submit elements on the day (pre-identification)',
  work_time_today: 'Working hours on the day',
  price_today: 'Hourly wage for the day',
  export_curr_page: 'Export current page',
  total_data: 'Total data',
  anno_not_collected: 'Marked as not collected',
  submitted: 'Submitted',
  acceptance: 'Acceptance',
  instance_type: 'Instance type',
  label_options: 'Label Options',
  batch_name_colon: 'Batch name：',
  ph_project_session: 'Please select the segment',
  session: 'Segment',
  total: 'Total',
  total_submit: 'Total submissions',
  invalid_data: 'Invalid data',
  empty_group: 'Empty group',
  group: 'Group',
  no_config: 'No configuration temporarily',
  other: 'Other',
  anno_rule_setting: 'Dimension Rule Settings',
  anno_rule_setting_tip: 'If you do not select a dimension rule, it means that you do not use the dimension rule.',
  ph_rule: 'Please select a rule',
  ph_version: 'Please select a version',
  whether_config_group_element: 'Whether to configure group elements',
  group_element: 'Group Elements',
  level_x: 'Level {value}',
  no_eligible_statistic: 'No eligible statistics',
  no_eligible_statistic: 'search complete',
  today_submission: 'New submission today',
  today_duration: 'Time on the day (hours)',
  under_repair: 'Under repair',
  terminal_person_colon: 'Terminal personnel:',
  terminal_person: 'Terminal personnel',
  ph_terminal_person: 'Please enter terminal personnel',
  ph_batch_name: 'Please select the batch name',
  ph_enter_batch_name: 'Please enter the batch name',
  once_pass_rate: 'One-time pass rate',
  two_time_pass_rate: 'Two-time pass rate',
  three_time_pass_rate: 'Three-time pass rate',
  four_time_pass_rate: 'Four-time pass rate',
  project_link_pass_rate: 'Segment pass rate',
  project_batch_pass_rate: 'Project batch pass rate',
  project_batch_success_rate: 'Project batch success rate',
  pre_identification_statistics: 'Has pre-identification statistics',
  pre_identification_statistics_no: 'No pre-identification statistics',

  // 质检管理
  quality_management: 'Quality inspection management',
  quality_message: 'The scope of the sampling is the data submitted in the annotation & quality control segment, the data in progress and the data under repair are not included in the sampling',
  project_batch_colon: 'Project batch：',
  project_batch: 'Project batch',
  header_project_batch: 'Project batch',
  ph_select_batch: 'Please select the project batch',
  project_session_colon: 'Segment：',
  ph_select_session: 'Please select the segment',
  submitter: 'Submitter：',
  submitter1: 'Submitter',
  ph_select_submitter: 'Please select the name of the submitter',
  last_submit_time: 'Last submission time:',
  screening: 'Screening',
  screening_count: 'Number of screenings:',
  quality_count: 'Number of samples tested:',
  create_quality_task: 'Generate sampling tasks',
  download_template: 'Click to download the import rework image template',
  quality_batch_id: 'Sample batch ID',
  submit_date: 'Submission date',
  creator: 'Creator：',
  header_creator: 'Creator',
  image_pass_rate: 'Picture pass rate',
  release: 'Release',
  tip_quality_count: 'Please enter a reasonable sampling quantity!',
  header_quality_count: 'Rejected/Inspected/Total sampling quantity',
  multiple: 'Batch',
  multiple_operate_unqualified_data_content: 'Are you sure to batch {name} all non quality inspection data under this task?',
  multiple_confirm: 'Determine the batch',
  tip_quality: 'All data under this task that has not been quality checked?',
  tip_copy_success: 'Copy succeeded!',
  tip_data_error: 'The data has not been claimed successfully, in principle this does not happen, please contact the administrator!',
  view_example: 'View Example',

  // 验收管理
  check_management: 'Acceptance management',
  check_pending: 'Pending acceptance',
  check_in: 'Acceptance in progress',
  check_submit: 'PM has been submitted',
  acceptance_passed: 'Acceptance rejected',
  acceptance_rejected: 'Acceptance pass rate',
  check_rate: 'Acceptance pass rate',
  ph_select_check_batch: 'Please select the batch',
  ph_select_team: 'Please select the team',
  image_filter_count: 'Number of filtered pictures:',
  check_count: 'Number of acceptance submissions:',
  submit_check: 'Submit for acceptance',
  select_check_count: 'Selected {count} piece of data',
  single_check_batch_count: 'Amount of data for a single acceptance batch * batches',
  message_batch_count: 'Please enter a reasonable number of batches!',
  message_single_batch_count: 'Please enter a reasonable amount of data for a single acceptance batch!',
  message_batch_max_count: 'The amount of data submitted must be less than the amount of data selected!',
  image_count: 'Number of pictures',
  undo: 'Withdrawn',
  submit_total: 'Reject data volume/Total submissions',
  sampling_count: 'Sampling quantity',
  header_check: 'Actual acceptance pictures / Actual acceptance object',
  data_right_rate: 'Picture pass rate',
  object_right_rate: 'Images pass rate',
  check_batch_status: 'Acceptance batch status',
  submit_time: 'Submission time',
  check_start_time: 'Start acceptance time',
  check_cost_time: 'Acceptance time',
  batch_data_receive: 'Data claim',
  submit_times: 'Submission Times',
  ph_submit_times: 'Please enter the number of submissions',

  // inspector1: '验收人',
  houer: 'Hour',
  minute: 'Minute',
  second: 'Second',
  day: 'Day',
  tip_no_check: 'No acceptable pictures/objects',
  tip_undo_success: 'Withdrawn successfully',
  tip_sampling_count: 'Please enter a reasonable sampling quantity!',
  batch_inspection: 'Batch inspection',
  reject_recheck: 'Reject data re verification',
  submit_check_msg: 'Please carefully check your verification options to ensure compliance with project requirements and operate with integrity. If the acceptance issue is caused by an incorrect selection, the platform cannot be held responsible. Are you sure to submit for verification?',
  ph_submit_check_msg: 'Special reminder: "Rejected data re verification" will only verify the rejected data from the previous round of acceptance, and other data will not be verified. Please use it according to project requirements!',
  choose_check_data: 'Please select verification data',
  pass_data_recheck: `The data that has passed the acceptance can be re accepted`,
  inhreit_last_check_config: `Inherit the previous sampling configuration`,
  ph_pass_data_recheck: `When the configuration is enabled, the acceptance end can change the acceptance result of the previous round's "acceptance passed" data; When the configuration is turned off, the data from the previous round of "acceptance pass" only participates in sampling and statistics, and the acceptance result cannot be changed.`,
  ph_inhreit_last_check_config: `When the configuration is enabled, a sampling task will be automatically generated based on the previous round's "sampling ratio" and "whether invalid data is included"; When the configuration is turned off, the acceptance end manually configures the "sampling ratio" and "whether invalid data is included".`,
  ph_reject_recheck: `Only the rejected data from the previous round of acceptance will be submitted for verification, and the acceptance end will only allow the acceptance of rejected data.`,
  re_submit_check: 're submit check',

  // 待发布
  pic_single_fram_annotation: ' Picture single frame annotation',
  pic_continuous_fram_annotation: 'Picture continuous frame annotation',
  pic_panoramic_semantic_egmentation_single: 'Picture panoramic semantic segmentation - single frame',
  pic_panoramic_semantic_egmentation_continuous: 'Picture panoramic semantic segmentation - consecutive frames',
  point_cloud_single_frame_annotation: 'Point cloud single frame annotation',
  point_cloud_single_frame_fusion_annotation: 'Point cloud single frame fusion annotation',
  point_cloud_continuous_frame_annotation: 'Point cloud continuous frame annotation',
  point_cloud_continuous_frame_fusion_annotation: 'Point cloud continuous frame fusion annotation',
  point_cloud_semantic_segmentation: 'Semantic segmentation of point clouds',
  point_cloud_continuous_semantic_segmentation: 'Semantic segmentation of point clouds continuous frame',

  project_released: 'Unpublished items',
  project_status: 'Project status',
  project_status_colon: 'Project status：',
  ph_project_status: 'Please select the project status',
  project_creator: 'Project creator',
  header_start_date: 'Start date',
  start_date: 'Start date：',
  header_end_date: 'End date',
  end_date: 'End date：',
  look_up_task: 'View tasks',
  edit: 'Edit',
  continue_create: 'Continue to improve',
  batch: 'Batch',
  data_batch: 'Data batch',
  send: 'Publish',
  annotation_send: 'Annotation publish',
  quality_inspection_send: 'Quality inspection publish',
  preview: 'Preview',
  task: 'Task',
  pause_project: 'Pause project',
  task_statistic: 'Task data statistic',
  clone_pro_config: 'Clone project configuration',
  choose_checker: 'Select acceptance personnel',
  choose_export_model: 'Select export template',
  export_batch_data: 'Export batch data',
  project_detail: 'Project detail',
  edit_base: 'Edit basic configuration',
  edit_expand: 'Edit extended information',
  edit_rule: 'Edit rule information',
  ph_select_checker: 'Please select the acceptor',
  export_template: 'Export template',
  ph_export_template: 'Please select the export template',
  nmae_method: 'File naming method',
  ph_name_method: 'Please select the file naming method',
  image_suffix: 'Please select the picture suffix',
  ph_image_suffix: '请选择图片后缀',
  all: 'All',
  status_improvement: 'Waiting for improvement',
  status_publish: 'Waiting for publish',
  confirm_project_publish: 'Are you sure you want to publish the project??',
  message_config: 'It is necessary to ensure that all configurations are correct.',
  tip_project_start: 'Project started successfully',
  confirm_project_clone: 'Are you sure to clone the project?',
  tip_export_template: 'Select export template successfully',

  // 进行中
  round_x: 'Round {value}',
  inspection_rounds: 'Inspection rounds',
  check_pic_num: 'Number of inspection pictures',
  check_obj_num: 'Number of inspection objects',
  error_pic_num: 'Number of error pictures',
  error_obj_num: 'Number of error objects',
  error_rate: 'Error rate',
  feedback_record: 'Feedback record',
  audit_records: 'Audit records',
  close_algorithm_calls: 'Are you sure to turn off algorithm calls?',
  close_algorithm_calls_content: 'After closing, images that have undergone pre recognition processing will not be affected, and images that have not undergone pre recognition processing will no longer be processed.',
  project_going: 'Ongoing Projects',
  ph_project_creator: 'Please enter the project creater',
  ph_project_creator2: 'Please select the project creator',
  distribution: 'Distribution',
  data_management: 'Data',
  statistic: 'Statistic',
  projet_pause: 'Pause project',
  projet_close: 'Close project',
  projet_clone: 'Clone project',
  export_data: 'Export',
  algorithm_start: 'Algorithm config',
  algorithm_close: 'Close algorithm call',
  push_start: 'Turn off message notification',
  push_close: 'Turn on message notification',
  clone_select: 'Please select the information to clone：',
  message_clone: 'Note: The basic information in the first step of the new project will be copied by default; Tool configuration, phase configuration and project rules correspond to all information under the process when creating a project',
  algorithm_config: 'Please configure the algorithm',
  ph_algorithm_config: 'Please select an algorithm',
  algorithm_add: 'Add Algorithm',
  algorithm_close2: 'Turn off algorithm',
  operation_success: 'Successful operation',

  // 算法abtest部分
  algorithm_name_version: 'Algorithm Name/Version',
  algorithm_config_add: 'Add Algorithm Configuration',
  algorithm_config_show: 'Annotation Page Display Configuration',
  algorithm_field_config: 'Field Configuration',
  algorithm_field_attribute: 'Algorithm Attribute Field',
  algorithm_field_tool: 'Tool Attribute Field',

  algorithm_show_modal_message: 'Please select the algorithm(s) to be displayed on the annotation page',
  algorithm_show_modal_name1: 'Auto Fit',
  algorithm_show_modal_name2: 'Intelligent Tracking',
  algorithm_show_modal_name3: 'Interpolation Calculation',
  algorithm_show_modal_name4: 'Auto Ground',
  ph_url: 'Please enter URL',
  association_project: 'Associated Project',
  ph_association_project: 'Please enter associated project number',
  corresponding: 'Corresponding',
  algorithm_field_config_add: 'Add Configuration',

  update_result: 'Update Result',
  export_result: 'Export Result',
  update_lastest: 'Last Updated Time',
  analysis_data: 'Data Speed Analysis',
  analysis_object: 'Object Speed Analysis',

  // 已完结
  project_finish: 'Completed Project',
  more: 'More',
  project_reopen: 'Reopen project',
  data_statistic: 'Data statistic',
  header_total: 'Completed/Total',
  statue_in: 'In progress',
  status_paused: 'Paused',

  // 终端人管理
  taggers_manager: 'Terminal',
  ph_name_account: 'Please enter your name/account number',
  terminal_new: 'New',
  disabled: 'Disabled',
  normal: 'Normal',
  user_id: 'User ID',
  header_name: 'Name',
  account: 'Account number',
  header_create_time: 'Creation time',
  last_login_name: 'Last login time',
  tip_personnel_success: 'Get the list of people successfully',
  tip_personnel_status: 'Change of personnel status successful',
  disable: 'Disable',
  assign_team: 'Assign Team',
  invalid_frame: 'Invalid frame',
  invalid_data: 'Invalid data',

  // 验收人管理
  acceptor_management: 'Acceptor',
  ph_company: 'Please enter your company name',
  tacceptor_new: 'New',

  // 供应商管理
  team_management: 'Team',
  team_name_colon: 'Team name：',
  header_team_name: 'Team name',
  ph_team_name: 'Please enter the team name',
  mobile: 'Mobile number：',
  ph_mobile: 'Please enter your mobile phone number',
  team_new: 'New team',
  team_association: 'Team account association',
  ph_hive: 'Please enter the correct hive ID',
  organisation_id: 'Organisation ID',
  hive_id: 'Hive ID',
  team_cpunt: 'Team size',
  tip_association_success: 'Successful association',

  //PM管理
  PM_management: 'PM management',
  PM_new: 'New PM',

  // 工具配置
  delete: 'Delete',
  copy: 'Copy',
  none: 'None',
  tool_new: 'New Tool',
  tool_view: 'View Tool',
  tool_edit: 'Editing Tool',

  id: 'ID',
  ph_id: 'Please enter ID',
  tool_name: 'Tool name：',
  header_tool_name: 'Tool name',
  ph_tool_name: 'Please enter the tool name',
  template_type: 'Template type：',
  header_template_type: 'Template type',
  ph_template_type: 'Please select the template type',
  used_project: 'Whether used by the project：',
  header_used_project: 'Whether used by the project',
  ph_used_project: 'Please select whether to be used',
  confirm_edit_tool: 'Are you sure to edit the tool? Editing will affect the project data in progress. Please modify it carefully.',
  confirm_delete: 'Are you sure to delete?',
  tip_delete_success: 'Deleted successfully',

  submit: 'Submit',
  message_back: 'Return to previous step',
  confirm_back: 'This operation will clear the current data, is it sure to return to the previous step?',

  class_image: 'Picture class',
  use_now: 'Use Now',
  class_3d: '3D class',
  range_circle: 'Range circle',
  ph_range_circle: 'Please enter "integer" or "integer * integer". Multiple range circles should be separated by "," and up to 5 are supported',
  message_range_circle: '"Integer": generates a circle with this radius; "Integer*integer": generates a rectangular circle with this length and width',
  point_color: 'Point cloud strategy',
  ph_point_color: 'Please select the point cloud colouring method',
  calibration_configuration: 'Calibration configuration',
  ph_calibration_configuration: 'Upload',
  box_config: 'Marker box configuration',
  mapping_type: 'Mapping Type',
  mapping_open: 'Whether to map',
  draw_independently: 'Draw independently',
  consistent_size: 'Size synchronization',
  pass_rate_stat_range: 'Scope of qualification rate statistics',
  stat_not_2d: '2D instances are not included',
  clond_on: 'Whether the point is on the point cloud point',
  frame_config: 'Frame property configuration',
  other: 'Other',
  segmented_load_4d: '4D segmented loading',
  message_inspector_modify: 'Allow the inspector to modify the annotation data',
  allow_repair_after_acceptance: 'Allow repair after acceptance',
  only_count_acceptance_frames: 'Only count acceptance frames',
  point_clouds_display_center: 'Point clouds are displayed as original data center points',
  support_hand_drawn_qa: 'Support hand-drawn quality inspection',
  frame_accuracy_requirements: 'Frame accuracy requirements',
  tip_verification_failed: 'Verification failed!',
  label_config: 'Label configuration',
  overall_attr: 'Overall property',
  tip_tool_name: 'Tool name already exists',
  graphical_config: 'Graphical configuration',
  auto_copy_config: 'Automatic replication configuration',
  auto_copy_same: 'Enable automatic copying between frames of the same shot',
  auto_copy_diff: 'Enable automatic copying between different shots',
  config_method: 'Configuration method',
  message_cover: 'You can copy the attributes of other graphs to this graph. If there is attribute data in this graph, it will be overwritten.',
  tag_message_cover: 'Just like multiple shapes need to be drawn under a label, click here to copy the label.',
  copy_attr: 'Copy Properties',
  copy_label_attr: 'Label copying',
  image_attr_config: 'Image property configuration',
  default_display: 'Default Display',
  defalut_display_tip: 'When checked, the label page displays the "entire image attribute" list by default',
  select_sort: 'Sort by selected',
  select_sort_tip: 'After checking, the label with attribute value will move forward',
  from_config_upload: 'From configuration upload',
  from_batch_upload: 'From batch upload',
  batch_upload_tip: 'Calibration configuration needs to be uploaded together with batch data',
  support_drag_adjustment: 'Map only without editing',
  other_config: 'Other configurations',
  entire_attr: 'Entire Chart Properties',
  tip_image_tool: 'Please select the graphics tool',
  confirm_cover: 'Label copying will overwrite the labels already added to the current drawing. Do you want to continue copying?',
  tip_tools_same: 'The tools configured for group elements and graphics should be consistent!',
  cloud_color: 'Point cloud color',
  depth_color: 'Depth Color',
  reflectance_color: 'Reflectance color',
  mapping_no: 'No mapping',
  mapping: 'Mapping',
  box_2d: '2D box',
  box_25d: '2.5D box',
  associable: 'Associable',
  associable_no: 'Non-associable',
  radio: 'Single choice',
  checkbox: 'Multiple choice',
  input: 'Input box',
  radio_tiled: 'Tiled Single Choice',
  radio_selection: 'Single selection drop down box',
  checkbox_tiled: 'Tiled Multiple Choice',
  checkbox_selection: 'Multi-selection drop-down box',
  support: 'Support',
  support_no: 'No support',
  required: 'Required',
  required_no: 'Not required',
  graphics_same: 'Same configuration for all graphics',
  graphics_diff: 'Different graphics have different configurations',
  semantic_segmentation: 'Semantic segmentation',
  object_segmentation: 'Instance segmentation',
  add_attr: 'Add property',
  use_config: 'Enable configuration',
  input_setting: 'Input box setting',
  message_chars: 'Number of characters>=',
  message_chars_and: ' and <=',
  message_chars_number: 'Note: When enabled, the number of characters will be limited according to the configuration, not enabled means no limit',
  tip_empty: '{value} cannot be empty',
  tip_repeat: '{value} repeat',
  tip_number: 'Only positive integers are supported',
  confirm_change_type: 'Switching the type will clear the option content. Are you sure you want to switch??',
  ph_min_chars: 'Please enter the minimum number of characters',
  ph_max_chars: 'Please enter the maximum number of characters',
  tip_max_chars: 'The maximum number of characters cannot be less than the minimum number of characters',
  number: 'Number',
  level: 'Level',
  attr: 'Property value',
  attr_name: 'Property name',
  name_display: 'Display name',
  name_export: 'Export name',
  label_attr: 'Label Properties',
  default_length: 'Default length (m)',
  default_width: 'Default width (m)',
  default_height: 'Default height (m)',
  attr_3d: '3D properties',
  attr_2d: '2D properties',
  attr_25d: '2.5D properties',
  division_type: 'Division type',
  whole_marking: 'Annotation of the whole drawing',
  input_required: 'Mandatory fields',
  default_item: 'Default item',
  aassociated_category: 'Associated category',
  // is_single_attr: '是否逐帧属性',
  // is_single_attr_tip: '若勾选，表示支持逐帧标注该属性，每一帧可有不同的属性值。',
  // is_instance_attr: '是否实例属性',
  // is_instance_attr_tip: '若勾选，表示实例ID的属性。适用于3D目标不存在但是2D存在，并且需要标注实例属性的场景。',
  is_single_attr: 'Frame by frame attribute',
  is_single_attr_tip: 'If checked, it means that the attribute is supported for frame-by-frame annotation, and each frame can have different attribute values. Only attributes with the same value can be associated',
  is_instance_attr: 'Instance attribute',
  is_instance_attr_tip: 'If checked, it means that the attribute is an instance attribute. It is applicable to scenarios where 3D objects do not exist but 2D objects exist, and the instance attribute needs to be annotated.',
  aassociated_attr: 'Associated property',
  attr_level: 'Property hierarchy',
  message_attr_level: 'Display the hierarchical value of the attribute on the annotation page',
  message_color_clear: '"Empty" color means that the attribute has no color and will not be filled in the label page',
  message_2d_node_color: 'After configuration, fill the nodes with the configured colors; If not configured, fill nodes with the color of the line by default',
  color_line: 'Color applied to line',
  color_node: 'Color applied to node',
  message_color_line: 'After activation, the color of the object border can be manually configured on the annotation page to match the attribute color, supporting color synchronization for rectangular boxes, polygons, line segments, points, and solid boxes.',
  message_2d_node_line: `After activation, fill the node with the corresponding attribute's color; Not enabled, defaults to filling nodes with line colors`,
  verify_attr: 'Verify that ID attributes are consistent',
  message_verify_attr: 'This check is used in conjunction with the Auto-Copy Configuration, i.e. if Auto-Copy is enabled between frames of the same shot, the same ID attribute is verified between frames of the same shot; if Auto-Copy is enabled between shots, the same ID attribute is verified between shots.',
  hot_key: 'Shortcut key',
  color: 'Color',
  node_attr_conig: 'Node Attribute Configuration',
  object_attr_conig: 'Object Attribute Configuration',
  spline: 'Curve',
  statistics_without_pre_anno: 'Pre annotated objects do not participate in statistics',
  is_allow_off_side: 'Allow out of bounds',
  single_receive_count: 'Single collection quantity',
  ph_single_receive_count: 'Please input single collection quantity',
  message_integer: 'Please enter a positive integer',
  import: 'import',
  import_confirm: 'The original configuration will be overwritten after importing. Do you confirm the import?',
  enum: 'Type error, only supported:',
  name_empty: 'Can not be empty',
  import_error_title: 'The import failed with the following error:',
  import_error_hot_key: 'Shortcut key duplication',
  import_error_empty: 'There is no content to import. Please check whether the sheet name of the imported file is correct.',
  import_error_only: 'There can only be one',
  download_template: 'Download template',
  import_success: 'Import successful!',
  import_success_link: 'Import successful! If you need an association relationship, please configure it manually on the platform!',
  import_upload_tip: 'Which object type is selected and the template of which object type is downloaded',
  import_tip: 'Which object type is selected, the attribute configuration of which object type is imported',
  unit_price: "Unit price",
  rmb: "RMB",
  mask_image: "Mask diagram",
  frame_attributes: "Frame properties",
  box_2d: "2D box",
  box_25d: "2.5D box",
  box_3d: "3D box",
  polygon_3d: "3D polygon",
  polyline_curve: "polylines and curves",
  sse_price: "Split unit price",
  sse_frame_price: "Frame attribute unit price",
  ocr_tip: 'After activation, OCR recognition is performed based on the language configured for the project',
  width_height_rate_error: 'Please enter the correct aspect ratio!',
  width_height_rate_tip: 'Please enter the ratio using a colon in English, such as 2:1. Not entering anything indicates no specific aspect ratio limitation.',

  // 数据规则
  your_upload_address: 'Your upload address',
  data_rules: 'Data rules',
  data_rules_import: 'Data import rules',
  data_rules_export: 'Data export rules',
  data_rules_new: 'New import rules',
  data_rules_management: 'Maintaining import rules',
  number2: 'Number',
  attr_parent_name: 'Parent attribute name',
  attr_parent_value: 'Parent attribute value',
  attr_sub_name: 'Sub attribute name',
  attr_sub_value: 'Sub attribute value',
  description: 'Description',
  header_update_time: 'Update time',
  ph_rules_import_name: 'Please enter the name of the import rule',
  ph_rules_import_description: 'Please enter the import rule description',
  confirm_delete_attr: 'Are you sure to delete the error property group?',
  message_delete_attr: 'You need to ensure that deleting this error property group does not affect existing projects',
  confirm_clone_attr: 'Are you sure to clone the wrong property group?',
  message_clone_attr: 'Clone all attributes and their relationships in this attribute group',
  export_rules_config: 'Maintaining export rules',
  ph_rules_export_name: 'Please enter the name of the export rule',
  ph_rules_export_description: 'Please enter the description of the export rule',
  error_attributes: 'Error attribute value list',
  new_error_attribute: 'New',
  eidt_error_attribute: 'Attribute value',
  attr_value_name: 'Value name',
  error_type: 'Error type',
  version_management: 'Version',
  import_versions: 'Import version list',
  new_import_version: 'New',
  edit_import_version: 'Version',
  json_version: 'JSON',
  ph_desc_rule: 'Please enter the description of the rule',
  ph_json_rule: 'Please enter the JSON of the rule',
  export_versions: 'Export version management list',
  new_export_version: 'New',
  edit_export_version: 'Version',
  ph_error_attr_value_color: 'Please enter the error attribute value color',
  ph_error_attr_value_type: 'Please enter the error attribute value value',
  ph_error_attr_value_name: 'please enter the error attribute value name',
  ph_error_attr_value_desc: 'please enter the error attribute value description',
  image: 'Image',

  // 框错误组
  error_management: 'Error Management',
  error_management_new: 'New error property group',
  error_management_edit: 'Maintain the error property group',
  error_attr_new: 'New box error property',
  error_attr_edit: 'Maintain error property',
  ph_error_name: 'Please enter the name of the error property',
  copy_success: 'Clone succeeded',
  clone: 'Clone',

  // 图片无效原因
  invalid_image: 'Invalid Reason',
  invalid_image_mew: 'New',
  invalid_image_edit: 'Maintenance Reasons for invalid images',
  code: 'Code',
  ph_invalid_image: 'Please enter the name of the reason why the picture is invalid',
  ph_invalid_image_description: 'Please enter the description of why the picture is invalid',

  // 标注规则配置
  rules_config: 'Annotation Rules',
  rules_config_new: 'New',
  citation_records: 'Citation',
  message_rules_config: 'Rule settings for labeling',
  description2: 'Description',
  rules_config_edit: 'Maintaining the labelling rules',
  rules_name: 'Rule name',
  ph_rules_name: 'Please enter the name of the rule',
  config_id: 'Configuration ID',
  version_current: 'Current version',
  citations_number: 'Refence',
  version_number: 'Version number',
  citations_time: 'Citation time',
  version: 'Version',
  ph_rules_config_name: 'Please enter the name of the labelling rule',
  ph_rules_config_content: 'Please enter the content of the labelling rule',
  tip_rules_save: 'Saving the labeling rules was successful!',
  select_scene: 'Please select a scene',

  // 公告管理
  announcement_management: 'Announcement',
  announcement_publish: 'Publish announcement',
  all_prople: 'All',
  published: 'Published',
  publish_stop: 'Stop publishing',
  announcement_edit: 'Maintain announcement',
  announcement_title: 'Announcement title',
  announcement_scope: 'Notification scope',
  announcement_content: 'Announcement content',
  announcement_details: 'Announcement details',
  announcement_id: 'Announcement ID',
  title: 'Title',
  status: 'Status',
  ph_announcement_title: 'Please enter the announcement title',
  ph_announcement_content: 'Please enter the announcement content',
  tip_announcement_save: 'Save the announcement successfully!',
  tip_announcement_edit: 'Modified status successfully!',

  // 管理日志
  management_log: 'Management Log',
  log_id: 'Log ID',
  user_name: 'User name',
  management_description: 'Operation description',

  // 导出记录
  export_records: 'Export records',
  export_new: 'New Export',
  local_download: 'Local download',
  export_batch: 'Export batch',
  ph_export_batch: 'Please select export batch',
  export_format: 'Export format',
  ph_export_format: 'Please select the export format',
  naming_method: 'Naming method',
  ph_naming_method: 'Please select the naming method',
  mask: 'mask chart',
  export_no: 'Do not export',
  raw_data: 'Raw data',
  export_dest: 'Export destination',
  export_oss: 'Export to OSS',
  export_local: 'Export to local',
  export_data_volume: 'Export data volume',
  search2: 'Enquiry',
  message_search: '{num} search in total',
  export_time: 'Export time',
  export_status: 'Export status',
  export_success: 'Export succeeded',

  // 批次管理 gpt
  excluding_data_rechecked: 'Excluding data to be rechecked',
  including_data_rechecked: 'Including data to be rechecked',
  last_round_inspector: 'Previous inspector',
  ph_last_round_inspector: 'Select previous inspector',
  data_to_be_rechecked: 'Data to be recheck',
  ph_data_to_be_rechecked: 'Select recheck data',
  quantity_to_be_rechecked: 'Quantity to be recheck',
  min_sampling_rate: 'Minimum ratio',
  ph_min_sampling_rate: 'Please enter the minimum ratio',
  tip_min_sampling_rate: 'Integer between【0,100】',
  enabled_or_not: 'Enabled or not',
  tip_close: 'Selecting "Close" means there is no limit to the sampling ratio.',
  tip_save_sampling_rate_success: 'Successfully saved the quality inspection strategy!',
  project_batch_management: 'Project batch management',
  refresh_batch: 'Refresh Batch',
  add_batch: 'Add Batch',
  unmarked: 'Unmarked',
  not_qa: 'Unqualified',
  not_qa_message: 'Data under this batch that has not yet started quality inspection',
  message_batch_total: 'The total amount of data under this batch that has not been received by the label operator',
  data_waiting_upload: 'Waiting for upload',
  pause: 'Pause',
  annotation_pause: 'Annotation pause',
  quality_inspection_pause: 'Quality inspection suspended',
  quality_inspection_strategy: 'Quality inspection strategy',
  empty_data: 'Emptying data',
  pre_recognition_toggle: '',
  import_rules: 'Import rules',
  select_import_template: 'Please select the import template',
  select_import_version: 'Please select the import version',
  version_details: 'Version details',
  upload_type: 'Upload Type',
  cos_path: 'COS path',
  oss_path: 'OSS path',
  zip_compression_package: 'Zip compression package',
  local_path: 'Local path',
  fill_oss_path: 'Please enter the OSS path',
  priority: 'Priority',
  ph_priority: 'Please select priority level',
  checkbox_setting: 'Check box：',
  header_checkbox_setting: 'Check box',
  batch_priority_instructions: 'Batch priority description: The larger the number, the higher the priority, such as Priority 5>Priority 1',
  oss_upload_instructions: 'OSS upload instructions: Please upload the path that removes the default OSS path, such as removing oss://speechocean-bj/ Upload ocr_ Test/ocr oss upload/is sufficient',
  edit_batch: 'Edit batch',
  batch_path: 'Batch name',
  copy_oss_address: 'Copy OSS address',
  import_version_details: 'Import version details',
  version_description: 'Version description',
  json_details: 'JSON details',
  // maintain_quality_inspection_strategy: '维护质检策略',
  upload_failed: 'Upload failed',
  fill_batch_name: 'Please enter the batch name',
  stop_batch_confirmation: 'Are you sure to stop the batch??',
  project_progress_not_counted: 'Project progress is not counted for batches that are in progress and have been discontinued.',
  // off: '关闭',
  // on: '开启',
  no_longer: 'no longer',
  will: 'will',
  confirmation1: 'Are you sure to',
  confirmation: 'Confirm',
  pre_identify: 'pre-identify',
  images_not_affected: 'Pictures already collected afterwards are not affected,Uncollected images',
  show_pre_recognition_results: 'display pre-recognition results',
  status_modified_successfully: 'Modify status successfully',
  batch_data_deleted: 'You have deleted the batch data',
  file_size_limit_exceeded: 'Upload file size must be less than 200M',
  single_file_upload_allowed: 'Only one batch data file can be uploaded for the time being',
  stop: 'Stop',
  sample_data: 'Sample Data',
  frameNumber: 'frameNumber',
  ground_algo_ornot: 'Is ground recognition performed',

  // 项目分配管理
  project_assignment_management: 'Project allocation management',
  project_assignment: 'Project allocation',
  // all: '全部',
  staff: 'Personnel',
  enable: 'Enable',
  // project_assignment: '项目分配',
  select_step: 'Select segment',
  select_vendor: 'Select team',
  optional: 'Optional',
  selected: 'Selected',
  receiving_range: 'Scope of collection',
  please_select_previous_step_vendor: 'Please select a team from the previous segment',
  vendor_name: 'Team name',
  please_select_step: 'Please select the segment',
  please_select_vendor: 'Please select the team',
  confirm_delete_vendor_X: 'Are you sure to delete team {name}?',
  save_vendor_success: 'Save the team successfully!',
  batch_range: 'Batch area',
  please_select_batch: 'please_select_batch',

  // 公告中心
  noticeCenter: 'Announcement Center',
  viewNotice: 'View announcement content',
  noticeDetails: 'Announcement details',
  publishTime: 'Publish time',

  // 首页
  waiting_to_be_released: 'Projects to be published',
  project: 'Project',
  in_progress: 'Ongoing Projects',
  completed: 'Completed Project',
  data: 'Data (images)',
  to_be_labeled: 'To be marked',
  to_be_inspected: 'To be inspected',
  to_be_reviewed: 'To be reviewed',
  to_be_accepted: 'To be accepted',
  ongoing_project_stats: 'Statistics on ongoing projects',
  message_center: 'Message center',
  latest_announcement: 'Latest announcement',
  total_amount: 'Total number (sheets)',
  daily_capacity: 'Average daily capacity (sheets)',
  progress: 'Progress',
  duration: 'Duration',
  deadline: 'Deadline',
  in_progress_task: 'Task in progress',
  completed_task: 'Completed task',
  pending_data: 'Data to be completed',
  completed_data: 'Completed data',
  project_name2: 'Project Title',

  // 供应商人员管理
  maintain_user_groups: 'Maintain User Groups',
  personnel_management: 'Personnel',
  enter_name: 'Please enter a name',
  enter_account: 'Please enter the account number',
  import_users_in_batch: 'Batch import of users',
  import_user: 'Import users',
  upload_error: 'Error in uploading file',
  check_fail_reason: 'Please click the file link to view the reason for upload failure',
  check_fail_file: 'Click to view the failed upload file',
  download_import_user_file: 'Click to download the imported user template',
  file_description: 'Document description',
  download_template_first: 'Please download the import template first, enter the sample format, and then modify and upload it.',
  last_login_time: 'Last login time',
  file_size_limit: 'Uploaded file size must be less than 10M',
  batch_upload_limit: 'Only one batch data file can be uploaded for the time being',

  // 算法管理
  algorithm_management: 'Algorithm Management',
  algorithm_list: 'Algorithm List',
  algorithm_call: 'Algorithm Call',
  interface_name: 'Interface Name',
  chinese_name: 'Chinese Name',
  english_name: 'English Name',
  ph_interface_name: 'Please enter interface name',
  ph_chinese_name: 'Please enter Chinese name',
  ph_english_name: 'Please enter English name',
  use_count: 'Times Used',
  developer: 'Developer',
  ph_developer: 'Please enter developer',
  interface_description: 'Interface Description',
  ph_interface_description: 'Please enter interface description',
  interface_create: 'Create Interface',
  interface_edit: 'Edit Interface',
  ph_version2: 'Please enter version',
  algorithm_name: 'Algorithm Name',
  algorithm_version: 'Algorithm Version',
  ph_algorithm_name: 'Please enter algorithm name',
  ph_algorithm_version: 'Please enter algorithm version',
  algorithm_open: 'Open Algorithm Call',
  result_analysis: 'Result Analysis',
  data_volume: 'Data Volume',
  data_volume_tip: 'For both single frames and consecutive frames, the data volume is measured in units of data pieces. One image per single frame is one piece of data, and one segment per consecutive frame is one piece of data.',
  control_group_flow_ratio: 'Control Group Flow Ratio(%)',
  control_group_flow_ratio_tip: 'The control group refers to the traffic that does not call the algorithm.',
  ph_data_volume: 'Please enter the data volume',
  ph_control_group_flow_ratio: 'Please enter the flow ratio of the control group',
  remaining_data_calling: 'Whether to call the algorithm for remaining data',
  data_calling: 'Whether to call the algorithm interface',
  data_calling_tip: 'Please enable this configuration for pre recognition algorithms, and disable this configuration for real-time algorithms and customer pre recognition data',
  static_num: 'Number of annotated/ submitted frames',
  static_num_qa: 'Number of annotated/ submitted frames',
  static_time: 'Speed (s/frame)',
  static_hour: 'Speed (frames/hour)',
  one_static_num: 'Number of annotated/ submitted frames in the first round of revision',
  one_static_time: 'Speed (s/frame) in the first round of revision',
  one_static_hour: 'Speed (frames/hour) in the first round of revision',
  data_volume_frame: 'Total data volume/ total number of frames',
  all_object_num: 'Total number of boxes',
  all_time: 'Total duration',
  tip_field: 'Please configure the corresponding relationship of the fields',
  // 供应商项目管理
  project_management: 'Project',
  input_project_id: 'Project ID',
  input_project_name: 'Please enter the project title',
  personnel: 'Personnel',
  link: 'Segment',
  rejected_submitted: 'Rejected / Total submission',

  // 供应商数据管理
  data_process: 'Segment：',
  select_data_process: 'Please select the segment',
  select_data_status: 'Please select the data status',
  select_terminal_user: 'Please select terminal personnel',
  select_date: 'Please select the date',
  found_x_data: '{num} data have been searched',
  upload_import_image: 'Upload and import pictures',
  import_image: 'Import picture',
  click_download_template: 'Click to download and import the rework image template',
  terminal_user: 'Terminal personnel',

  // 人员
  project_personnel_management: 'Project personnel management',
  add: 'Add',
  add_personnel: 'Add people',
  select_user: 'Select user',
  personnel_statistics: 'Personnel statistics',
  join_time: 'Joining time',
  completion: 'Completed/Total',
  avg_daily_output: 'Average daily production (pictures)',
  avg_error_rate: 'Average error rate (objects)',
  avg_rework_rate: 'Average rework rate (tasks)',
  select_terminal_person: 'Please select terminal personnel',
  add_user_success: 'Add user successfully!',
  save_personnel_success: 'Save personnel successfully!',
  maintenance_user: 'Maintenance User',
  role: 'Role',
  ph_role: 'Please select the role',
  ph_reset_password: 'Please enter the reset password',
  team_number: 'Team Number',
  ph_team_number: 'Please enter the team number',

  // 供应商统计
  submit_progress: 'Submission progress',
  data_statistics: 'Data statistic',
  update_statistics: 'Update',
  export_statistics: 'Export',
  upload_import_images: 'Upload and import pictures',
  today_new_submissions: 'New submissions today',
  total_submissions: 'Total submissions',
  invalid_images: 'Invalid image',

  // 消息中心
  notice_detail: 'Announcement details',
  message_status: 'Message status',
  selected_X: '{num} items selected',
  mark_as_read: 'Batch set to read',
  unread: 'Unread',
  read: 'Read',
  content: 'Content',
  time: 'Time',
  NO: 'NO',

  // 公告中心
  notice_center: 'Announcement Center',
  view_notice: 'View announcement content',
  publish_time: 'Publish Time',

  // 质检管理 质检端
  quality_control_scope: 'Scope',
  select_submitter: 'Please select the submitter',
  last_submission_time: 'Last submission time:',
  sample_quantity: 'Sampling quantity:',
  generate_sample_task: 'Generate sampling tasks',
  download_rework_template: 'Click to download the import rework image template',
  sample_task_id: 'Task ID',
  submitted_data_percentage: 'Submitted data/total sampling quantity',
  passed: 'Passed',
  rejected: 'Rejected',
  enter_valid_sample_quantity: 'Please enter a reasonable sampling quantity!',
  confirm_batch_quality_inspection: 'Are you sure to batch operate all the unqualified data under this task?',
  rectangle2: 'Rectangle',
  collector: 'Collector',
  ph_collector: 'Please select the collector',
  collection_upload_time: 'Collection upload time',
  unlimited: 'Unlimited',
  // 统计
  batch_id: 'Batch id',
  add_time: 'Add Time',
  algorithm_invocation: 'Algorithm Call',
  oss_copy: 'Copy OSS Address',
  start_recognition: 'Enable pre-identification',
  stop_recognition: 'Disablef pre-identification',
  details: 'Details',
  company: 'Company',
  associate: 'Associate',
  maintain_inspector: 'maintenance inspector',
  reset_password: 'reset_password',
  fill_phone_or_email: 'Please enter the mobile phone number company email',
  fill_company_name: 'Please enter the company name',
  invalid_phone_or_email_format: 'Mobile phone number Company email format is incorrect',
  choose_user_role: 'Please enter and choose a user role',
  company_name: 'Company Name',
  save_success: 'Saved success',
  attribute_configuration: 'Attribute Config',
  edit_session_configuration: 'Edit Segment Configuration',
  header_total_pass: 'Unaccalimed/Total/Pass',
  same_3d_box_sizes_num: 'The number of allowed sizes for the same 3D box',
  same_3d_box_sizes_num_tip: "0 represents that the consistency of the same 3D frame size will not be verified during submission; When submitting a positive integer, size consistency will be checked. For example, if you enter 2, it means that the same object can have up to 2 sizes in all frames.",

  merge_max_frames: 'Maximum frame rate for point cloud overlay',
  merge_max_frames_tip: 'To ensure smooth operation, please fill in the maximum frame rate for point cloud overlay reasonably, with a limit of no more than 20 frames',
  auto_tracking_frames: 'Maximum frame num for auto track',
  auto_tracking_frames_tip: 'To ensure algo, please fill in the maximum frame for auto track reasonably, with a limit of 10-20',

  clear: "clear",

  goto_data_manager_list: "Go to data manager list",

  Chinese: "Chinese",
  English: "English",
  French: "French",
  German: "German",
  Korean: "Korean",
  Japanese: "Japanese",
  Traditional_Chinese: "Traditional Chinese",
  Vietnamese: "Vietnamese",
  Spanish: "Spanish",
  Portuguese: "Portuguese",
  Italian: "Italian",
  Arabic: "Arabic",
  Thai: "Thai",
  Hindi: "Hindi",
  Flat_Single_Select: "Flat Single Select",
  Dropdown_Single_Select: "Dropdown Single Select",
  Flat_Multiple_Select: "Flat Multiple Select",
  Dropdown_Multiple_Select: "Dropdown Multiple Select",
  Input_Box: "Input Box",
  Format_Error: "Format Error",
  Missing: "Missing",
  Column: "Column",
  Box_Template: "Box Template",
  Polygon_Template: "Polygon Template",
  Line_Template: "Line Template",
  Curve_Template: "Curve Template",
  Point_Template: "Point Template",

  operator: 'Operator',
  is_off_shelf: "Unavailable",
  document_status: "Document status",
  sort: 'Sort',
  create_time: "Create time",
  last_change_time: "Latest change time",
  create_document: "Create document",
  edit_document: "Edit document",
  off_shelf: "Disable",
  document_name: "Document name",
  ph_document_name: "Please enter the document name",
  document_address: "Document address",
  ph_document_address: "Please enter the document address",
  document_desc: "Document description",
  ph_document_desc: "Please enter the document description",
  visible_range: "Visible range",
  ph_visible_range: "Please enter the visible range",
  confirm_delete_this_data: 'Are you sure delete this data?',
  checkTagInfo: 'In multi-select type, properties cannot be associated repeatedly, some properties have been reset, please check！',
  checkInspectorInfo: 'This acceptance batch has been claimed by "{name}". Continuing the operation may overwrite the existing acceptance results. Are you sure you want to continue?',
  checkInspectorInfo2: 'The acceptance batch of data ID {ids} has been claimed by {idsName}. Continuing the operation may overwrite the existing acceptance results. Are you sure you want to continue?',

  date_type: 'Date Filter',
  time_type_day: 'Day',
  time_type_week: 'Week',
  time_type_month: 'Month',
  time_type_quarter: 'Quarter',
  time_type_year: 'Year',
  chart_analyze_left_1: 'Cumulative working time of the team',
  chart_analyze_right_1: 'Team work duration per {type}',
  chart_analyze_left_2: 'Cumulative data submitted by the annotation team',
  chart_analyze_right_2: 'The amount of data submitted by the annotation team per {type}',
  chart_analyze_left_3: 'The total amount of data submitted by the quality inspection team',
  chart_analyze_right_3: 'The amount of data submitted by the quality inspection team per {type}',
  chart_analyze_left_4: 'Average speed of the annotation team',
  chart_analyze_right_4: 'Annotation team every {type} times speed',
  chart_analyze_left_5: 'Average speed of quality inspection team',
  chart_analyze_right_5: 'The quality inspection team is {type} times faster',
  chart_analyze_left_6: 'Cumulative data submitted by annotators',
  chart_analyze_right_6: 'The amount of data submitted by annotators per {type}',
  chart_analyze_left_7: 'Cumulative data submitted by quality inspectors',
  chart_analyze_right_7: 'The amount of data submitted by the quality inspector for each {type}',
  chart_analyze_left_8: 'Average speed of annotators',
  chart_analyze_right_8: 'Annotator speed per {type}',
  chart_analyze_left_9: 'Average speed of quality inspectors',
  chart_analyze_right_9: 'Quality inspector per {type} times speed',
  unit_frame: 'Frame',
  unit_speed: 'Unit/s',
  chart_empty: 'There are no records in the query range',
  unit_indivual: 'Unit',
  chart_empty: 'There are no records in the query range',
  chart_statistics_type1: 'Image Annotation',
  chart_statistics_type2: 'Image Segmentation',
  chart_statistics_type3: 'Point cloud annotation',
  chart_statistics_type4: 'Point cloud segmentation',
  points_count_2d: ' 2D-Point',
  line_count_2d: ' 2D-Line',
  rectangle_count_2d: '2D-Rectangle',
  polygon_count_2d: ' 2D-Polygon',
  pseudo_count_2d: ' 2D-Pseudo',
  points_count_2d3d: 'Fusion-Point',
  line_count_2d3d: 'Fusion-Line',
  rectangle_count_2d3d: 'Fusion-Rectangle',
  polygon_count_2d3d: 'Fusion-Polygon',
  pseudo_count_2d3d: 'Fusion-Pseudo',
  point_count_3d: 'Point Cloud Point',
  line_count_3d: 'Point Cloud Line',
  object_count_3d: 'Point Cloud Rectangle',
  polygon_3d: 'Point Cloud Polygon',
  class_video: 'video annotation',
  bev_2d: '2D annotation of point cloud from Bev perspective',
  VideoFramePrice: 'video frame properties',
  video_frame_price: 'video properties',
  video_key_price: 'keyframe',
  stepInfo: 'Please enter video frame step',
  video_attr_setting: 'Video Properties Settings',
  table_list_show: 'Object List View',
  step: 'step',
}
